(function () {
  function getCardState(card) {
    if (card.__quickAddState) return card.__quickAddState;

    const container = card.querySelector('[data-quick-add-sizes]');
    if (!container) return null;

    const variantsScript = container.querySelector('[data-quick-add-variants]');
    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      variants = [];
    }

    const state = {
      container,
      row: container.querySelector('.card__quick-add-sizes-row'),
      variants,
      sizePosition: parseInt(container.dataset.sizeOptionPosition, 10),
      colorPosition: container.dataset.colorOptionPosition
        ? parseInt(container.dataset.colorOptionPosition, 10)
        : null,
      selectedColor: container.dataset.initialColor || null,
    };
    card.__quickAddState = state;
    return state;
  }

  function matchVariant(state, sizeValue) {
    const sizeKey = `option${state.sizePosition}`;
    const colorKey = state.colorPosition ? `option${state.colorPosition}` : null;

    return (
      state.variants.find((variant) => {
        if (variant[sizeKey] !== sizeValue) return false;
        if (colorKey && state.selectedColor) return variant[colorKey] === state.selectedColor;
        return true;
      }) || null
    );
  }

  function refreshAvailability(card) {
    const state = getCardState(card);
    if (!state) return;

    state.container.querySelectorAll('.card__quick-add-size').forEach((button) => {
      const variant = matchVariant(state, button.dataset.sizeValue);
      const available = !!(variant && variant.available);
      button.toggleAttribute('data-unavailable', !available);
      button.disabled = !available;
    });
  }

  function addToCart(card, variantId, triggerButton) {
    if (!variantId) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    if (triggerButton) triggerButton.classList.add('is-loading');

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('card-quick-add: add to cart failed', response);
          return;
        }
        // Same as product-form.js's own add-to-cart handler: the cart
        // drawer's is-empty class has to come off *before* renderContents
        // replaces its markup, or the drawer's own transitionend/open
        // handler tries to focus-trap the now-gone .drawer__inner-empty
        // (still looking for it because is-empty was never cleared) and
        // throws — this was only ever hit on the very first add to cart
        // of a session, when the drawer actually starts out empty.
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (cart) cart.renderContents(response);
      })
      .catch((error) => console.error('card-quick-add:', error))
      .finally(() => {
        if (triggerButton) triggerButton.classList.remove('is-loading');
      });
  }

  // card-swatches.js dispatches this on the card whenever a color swatch is
  // activated, so the size row's availability stays in sync with whichever
  // color is currently selected without the two files depending on each
  // other's internals.
  document.addEventListener('card:color-change', (event) => {
    const card = event.target.closest ? event.target.closest('.card') : null;
    if (!card) return;
    const state = getCardState(card);
    if (!state) return;
    state.selectedColor = event.detail.color;
    refreshAvailability(card);
  });

  function handleSizeActivation(event) {
    const button = event.target.closest('.card__quick-add-size');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    // pointerdown and click both fire for a single mouse interaction (by
    // design, so touch and mouse both get instant feedback — see below);
    // without this guard the same click would call addToCart twice.
    const now = Date.now();
    if (button.__lastActivated && now - button.__lastActivated < 500) return;
    button.__lastActivated = now;

    const card = button.closest('.card');
    const state = card && getCardState(card);
    if (!state) return;

    const variant = matchVariant(state, button.dataset.sizeValue);
    if (!variant || !variant.available) return;

    addToCart(card, variant.id, button);
    if (state.row) state.row.classList.remove('is-touch-active');
  }

  // Mouse: instant feedback on pointerdown (matches the swatch pattern),
  // click kept as a safety net for any input type. Touch is handled
  // separately below via real touch events, since pointerdown alone can't
  // express "reveal while held, act on release position".
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'touch') return;
    handleSizeActivation(event);
  });
  document.addEventListener('click', handleSizeActivation);

  // Touch: a plain tap on the product photo toggles the size row open or
  // closed (never navigates from there — that felt unintuitive to real
  // users); tapping a revealed size adds it to cart (handled by the
  // click-based logic above, since a genuine tap's synthesized click
  // still fires there); tapping anything else — the title, another
  // card, empty space — closes whichever row is currently open. The
  // product title link itself is untouched and still navigates normally,
  // since a tap there never lands inside any card's .card__media box.
  let openRow = null;
  let touchStartPoint = null;
  const TAP_MOVE_TOLERANCE_PX = 10;

  function closeOpenRow() {
    if (openRow) {
      openRow.classList.remove('is-touch-active');
      openRow = null;
    }
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.touches[0];
      touchStartPoint = { x: touch.clientX, y: touch.clientY };
    },
    { passive: true }
  );

  document.addEventListener('touchend', (event) => {
    const start = touchStartPoint;
    touchStartPoint = null;
    const touch = event.changedTouches && event.changedTouches[0];
    if (!start || !touch) return;

    // A real drag/scroll, not a tap: leave it alone entirely (don't open,
    // close, or preventDefault anything).
    const dx = Math.abs(touch.clientX - start.x);
    const dy = Math.abs(touch.clientY - start.y);
    if (dx > TAP_MOVE_TOLERANCE_PX || dy > TAP_MOVE_TOLERANCE_PX) return;

    const sizeButton = event.target.closest && event.target.closest('.card__quick-add-size');
    if (sizeButton) return; // handled by the shared click-based add-to-cart logic

    // Geometry-based, not event.target.closest('.card__media'): the
    // full-card ::after click overlay (see component-card.css) sits on
    // top of the photo, so a tap there always targets that overlay's
    // host <a>, never a .card__media descendant — event.target can't
    // tell us "this landed on a photo" here, only where it actually did.
    let matchedState = null;
    const containers = document.querySelectorAll('[data-quick-add-sizes]');
    for (let i = 0; i < containers.length; i++) {
      const card = containers[i].closest('.card');
      const media = card && card.querySelector('.card__media');
      if (!media) continue;
      const rect = media.getBoundingClientRect();
      if (
        touch.clientX >= rect.left &&
        touch.clientX <= rect.right &&
        touch.clientY >= rect.top &&
        touch.clientY <= rect.bottom
      ) {
        matchedState = getCardState(card);
        break;
      }
    }

    if (!matchedState || !matchedState.row) {
      closeOpenRow();
      return;
    }

    event.preventDefault(); // a tap on the photo now toggles sizes, never navigates
    const wasOpen = matchedState.row === openRow;
    closeOpenRow();
    if (!wasOpen) {
      matchedState.row.classList.add('is-touch-active');
      openRow = matchedState.row;
    }
  });

  // Mobile card redesign's always-visible "quick buy" button: opens the
  // exact same size row as tapping the photo (same openRow/closeOpenRow
  // bookkeeping, so the two triggers never fight over what's open), rather
  // than building a second reveal mechanism.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mobile-quick-buy]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const card = button.closest('.card');
    const state = card && getCardState(card);
    if (!state || !state.row) return;

    const wasOpen = state.row === openRow;
    closeOpenRow();
    if (!wasOpen) {
      state.row.classList.add('is-touch-active');
      openRow = state.row;
    }
  });

  document.querySelectorAll('[data-quick-add-sizes]').forEach((container) => {
    const card = container.closest('.card');
    if (card) refreshAvailability(card);
  });
})();
